import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const Composition3DRotationPreview = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 1816,
				height: 1440,
				translate: '52px -193.3px',
				scale: 1.081,
			}}
			from={-134}
		>
			<Video
				src="https://remotion.media/studio-close-ups/3d-rotation-2026-09-22-4d40c9da.mp4"
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						-120, -94, -93, -41, -34, -33, -13, -9, 23, 108, 111, 137, 196, 199,
						306, 317, 318, 375, 380, 382, 395, 396, 446, 476, 477, 521, 533,
						540, 575, 668, 669, 816, 893, 894,
					],
					[
						'auto',
						'ns-resize',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'custom',
						'ns-resize',
						'auto',
						'custom',
						'ns-resize',
						'custom',
						'ns-resize',
						'auto',
						'custom',
						'auto',
						'ew-resize',
						'custom',
						'ew-resize',
						'auto',
						'ew-resize',
						'auto',
						'ew-resize',
						'auto',
						'ns-resize',
						'auto',
						'default',
						'auto',
						'custom',
						'auto',
						'default',
						'auto',
					],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2229%22%20height%3D%2230%22%20viewBox%3D%220%200%2083%2085%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M58.673%2035.4941C58.6612%2035.1059%2058.6552%2034.9899%2058.6346%2034.4705L58.605%2033.8746C58.608%2033.9357%2058.5753%2033.3889%2058.5813%2033.4469L58.5695%2033.2635L54.9726%2033.508V33.5201C54.9874%2033.7371%2054.9992%2033.9389%2055.011%2034.1587C55.011%2034.1556%2055.0851%2036.3955%2055.0851%2036.3924L55.0881%2036.4688L55.0851%2036.4382L55.0881%2036.5268V36.591V36.5604V36.6521V36.6246V36.7163V36.6857L55.0911%2036.7927L55.0881%2036.7621L55.0911%2036.8844V36.8538V36.9913V36.9607V37.1441L55.0908%2037.1166V37.3C55.0908%2040.1263%2054.8952%2043.0781%2054.4568%2046.0083C55.7693%2045.6263%2057.0555%2045.1771%2058.273%2044.6517C58.5605%2042.2072%2058.6966%2039.7506%2058.6966%2037.3031C58.6936%2036.9149%2058.6906%2036.527%2058.6848%2036.1389L58.673%2035.4941ZM21.7249%2051.5816L11.6923%2048.5781L13.6418%2046.4055C11.1501%2043.9916%209.3219%2040.9118%209.3219%2037.3C9.33972%2034.501%2010.3589%2032.133%2012.0242%2029.9697C14.4835%2026.8805%2017.9916%2024.5982%2021.9176%2022.9633C21.5738%2024.4421%2021.2893%2025.9362%2021.0613%2027.4426C19.3486%2028.3349%2017.7752%2029.386%2016.4095%2030.6144C14.7415%2032.1421%2013.3428%2034.0304%2013.0051%2036.3039C12.7799%2037.8317%2013.0852%2039.2831%2013.7724%2040.6338C14.3562%2041.7765%2015.1886%2042.8063%2016.0896%2043.674L18.0364%2041.5015L21.7249%2051.5816ZM34.2108%2019.8313C36.6997%2019.5167%2039.1175%2019.3792%2041.3219%2019.3792C46.5515%2019.3792%2051.8463%2020.0576%2056.8656%2021.5854C63.7397%2023.6785%2073.2715%2028.711%2073.3219%2037.3001C73.3041%2040.096%2072.2879%2042.464%2070.6226%2044.6274C64.2492%2052.639%2050.8152%2055.221%2041.3218%2055.221C38.6848%2055.221%2035.9232%2055.056%2033.3307%2054.6647L33.8196%2050.9828C36.2492%2051.3495%2038.8536%2051.5022%2041.3248%2051.5022C49.3544%2051.5022%2059.9855%2049.6047%2066.2374%2043.9856C68.1455%2042.2377%2069.6953%2040.0224%2069.7189%2037.3C69.6804%2032.8542%2065.5411%2029.6123%2062.0922%2027.7239C55.9115%2024.3841%2048.2344%2023.0948%2041.3218%2023.0948C38.7026%2023.0948%2035.8047%2023.2965%2032.8715%2023.7639C33.2479%2022.4132%2033.6923%2021.0965%2034.2108%2019.8313ZM50.8745%2058.1816C52.3146%2057.9493%2053.7634%2057.6652%2055.1974%2057.317C52.6789%2063.6206%2048.1633%2070.2572%2041.3218%2070.3C38.6077%2070.2816%2036.3114%2069.2337%2034.2137%2067.5163C26.4448%2060.9408%2023.9441%2047.09%2023.9441%2037.3C23.9441%2031.91%2024.602%2026.4466%2026.0834%2021.2705C28.1131%2014.1817%2032.9931%204.35195%2041.322%204.3C45.63%204.3%2049.1057%207.12951%2051.5916%2010.5272L53.8967%208.76404L55.7041%2019.3699L46.3885%2014.5025L48.6936%2012.7393C46.9723%2010.3347%2044.3528%208.01873%2041.3217%208.01873C37.0106%208.05836%2033.8669%2012.3302%2032.0358%2015.8868C28.7972%2022.2546%2027.5469%2030.1715%2027.5469%2037.3001C27.5469%2045.5806%2029.387%2056.544%2034.8388%2062.9912C36.5337%2064.9589%2038.6788%2066.5571%2041.3217%2066.5815C45.6328%2066.5418%2048.7765%2062.2731%2050.6076%2058.7165L50.8745%2058.1816Z%22%20fill%3D%22black%22%20stroke%3D%22white%22%20stroke-width%3D%223%22%20stroke-linejoin%3D%22round%22%20paint-order%3D%22stroke%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2283%22%20height%3D%2285%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%225%22%20stdDeviation%3D%223.15%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.25%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 15 13, alias'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[
							-134, -73, -67, 11, 16, 54, 89, 159, 196, 237, 291, 344, 375, 468,
							519, 567, 665, 686, 751, 847, 854, 933, 939,
						],
						[
							1.8079894063120725, 1.6271904656808653, 1.8079894063120725,
							1.6271904656808653, 1.8079894063120725, 1.6271904656808653,
							1.8079894063120725, 1.6271904656808653, 1.8079894063120725,
							1.6271904656808653, 1.8079894063120725, 1.6271904656808653,
							1.8079894063120725, 1.6271904656808653, 1.8079894063120725,
							1.6271904656808653, 1.8079894063120725, 1.6271904656808653,
							1.8079894063120725, 1.6271904656808653, 1.8079894063120725,
							1.6271904656808653, 1.8079894063120725,
						],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-120, -119, -118, -117, -116, -115, -114, -113, -112, -111, -110,
							-109, -108, -107, -106, -105, -104, -103, -102, -101, -100, -99,
							-98, -97, -96, -95, -94, -93, -92, -91, -90, -89, -88, -87, -86,
							-85, -84, -83, -82, -81, -80, -79, -78, -77, -43, -42, -41, -40,
							-39, -38, -37, -36, -35, -34, -33, -32, -31, -30, -29, -28, -27,
							-26, -25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15, -14,
							-13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 53, 54, 55, 56, 57,
							58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73,
							74, 75, 76, 77, 78, 79, 80, 81, 82, 84, 85, 86, 87, 88, 89, 90,
							91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
							106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
							119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 133,
							134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146,
							147, 148, 149, 150, 160, 161, 162, 163, 164, 165, 166, 167, 168,
							169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181,
							182, 183, 184, 185, 186, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 237, 238, 239, 240, 241, 242,
							243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255,
							256, 257, 258, 259, 260, 261, 262, 263, 264, 266, 267, 268, 269,
							270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282,
							283, 284, 285, 286, 293, 294, 295, 296, 297, 298, 299, 300, 301,
							302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314,
							315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327,
							328, 329, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354,
							355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367,
							368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380,
							381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393,
							394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406,
							407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419,
							420, 421, 425, 426, 427, 428, 435, 436, 437, 438, 439, 440, 441,
							442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454,
							455, 456, 457, 458, 459, 474, 475, 476, 477, 478, 479, 480, 481,
							482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494,
							495, 496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507,
							508, 509, 510, 511, 512, 513, 520, 521, 522, 523, 524, 525, 526,
							527, 528, 529, 530, 531, 532, 533, 534, 536, 537, 538, 539, 540,
							541, 542, 543, 544, 545, 546, 549, 550, 551, 552, 553, 554, 555,
							556, 557, 558, 559, 560, 569, 570, 571, 572, 573, 574, 575, 576,
							577, 578, 579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589,
							590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602,
							603, 604, 605, 606, 607, 608, 609, 610, 611, 612, 613, 614, 615,
							616, 617, 618, 619, 620, 621, 622, 623, 624, 625, 626, 627, 628,
							629, 630, 631, 632, 633, 634, 635, 636, 637, 638, 639, 640, 641,
							642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 667,
							668, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680,
							681, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702,
							703, 704, 705, 706, 707, 708, 709, 710, 711, 712, 713, 714, 715,
							716, 717, 718, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768,
							769, 770, 771, 772, 815, 816, 817, 818, 819, 820, 821, 822, 823,
							824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 887, 888, 889,
							890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902,
							903, 904, 905, 906, 907, 908, 909, 910, 911, 912, 913, 914, 915,
							916, 917, 918, 925, 926, 927, 928, 929, 930, 931, 932, 933,
						],
						[
							'919.8922975060693px 1997.5740454645775px',
							'921.2482895608034px 1910.112557934231px',
							'921.2482895608034px 1910.112557934231px',
							'916.9472522621938px 1647.1207239020084px',
							'909.7152946369455px 1556.0361951004195px',
							'894.6651953211212px 1479.3378945045245px',
							'871.5073935113662px 1396.5658794967999px',
							'857.1988523504746px 1342.1990730523064px',
							'855.8075480026484px 1333.611123372324px',
							'855.087177223571px 1330.0445817700288px',
							'853.5475612447584px 1325.8777311851688px',
							'849.9668947252263px 1317.0072831604502px',
							'843.3846832928714px 1304.789229750607px',
							'830.5945707349372px 1282.8956080335468px',
							'821.0108143897595px 1265.1547119841096px',
							'817.6349591701612px 1254.7305230633415px',
							'815.1913484881925px 1243.1127786360628px',
							'813.9977929816818px 1230.0048554403002px',
							'813.9977929816818px 1219.4817920988744px',
							'813.9977929816818px 1218.9732950783493px',
							'813.9977929816818px 1218.5424851026264px',
							'813.9977929816818px 1218.08342529243px',
							'813.6799823438535px 1216.8051202824984px',
							'812.3239902891195px 1213.4928271904657px',
							'810.579563010373px 1207.8922975060693px',
							'806.7375855219599px 1195.3846832928714px',
							'802.1611123372325px 1181.5069521077025px',
							'800.2966232619731px 1170.1505186493048px',
							'799.7951887000662px 1157.2191569190024px',
							'799.2655043036858px 1151.3361288898698px',
							'798.9759435003311px 1148.4405208563232px',
							'798.8841315382919px 1147.811962039285px',
							'798.608695652174px 1146.9644670050761px',
							'798.5380710659899px 1146.491282277643px',
							'798.5380710659899px 1145.9404105054073px',
							'798.3615096005298px 1145.5449128227765px',
							'798.0790112557935px 1144.59854336791px',
							'797.6693886559259px 1143.7227984992276px',
							'797.2315162215847px 1142.5433679099538px',
							'797.0196424630325px 1141.4063120723902px',
							'796.9702052527036px 1141.0602516000883px',
							'796.9490178768484px 1140.7495034208785px',
							'796.9490178768484px 1140.601191789892px',
							'796.9490178768484px 1140.5870668726552px',
							'796.9490178768484px 1140.5870668726552px',
							'798.8488192451998px 1130.629000220702px',
							'802.3235488854558px 1123.128669167954px',
							'802.3235488854558px 1123.128669167954px',
							'807.2672699183404px 1114.4065327742221px',
							'815.7634076362834px 1099.25755903774px',
							'819.9938203487089px 1092.082101081439px',
							'822.861178547782px 1086.4250717280954px',
							'827.6848377841536px 1078.684617082322px',
							'834.4930478922976px 1068.6559258441846px',
							'840.093577576694px 1060.6682851467667px',
							'846.018980357537px 1051.9249613771794px',
							'849.7550209666741px 1042.9627013904217px',
							'852.6576914588392px 1035.9991171926727px',
							'855.8428602957405px 1027.785477819466px',
							'857.9404105054073px 1020.5888324873097px',
							'859.1410284705364px 1014.635179871993px',
							'860.9843301699404px 1007.685720591481px',
							'863.7951887000663px 999.3378945045245px',
							'865.1582432134187px 995.0015449128229px',
							'866.4153608474951px 989.2809534319135px',
							'866.5636724784816px 987.4941514014567px',
							'866.8108585301259px 984.5067314058707px',
							'867.2275435886119px 980.6930037519312px',
							'867.6866033988083px 976.3566541602296px',
							'867.8843522401237px 973.8494813506952px',
							'868.1103509159127px 971.3988082101082px',
							'868.3363495917017px 969.0046347384684px',
							'868.7671595674244px 966.6387111013022px',
							'868.795409401898px 963.8772897815053px',
							'868.8307216949901px 960.6285588170382px',
							'869.1202824983447px 956.3840211873759px',
							'869.3462811741338px 953.622599867579px',
							'869.6005296843964px 950.5080556168617px',
							'869.7135290222909px 947.7819465901567px',
							'869.8689031118959px 945.0346501875966px',
							'870.1302140807769px 942.1390421540499px',
							'870.3350253807107px 940.0485544030016px',
							'870.5398366806445px 938.1558154932686px',
							'870.7446479805783px 936.3266387111014px',
							'870.8858971529464px 935.3943941734717px',
							'871.0624586184066px 934.236150960053px',
							'871.2037077907747px 933.7276539395277px',
							'871.2813948355772px 933.4875303465019px',
							'871.2813948355772px 933.4875303465019px',
							'869.3957183844626px 933.3109688810417px',
							'860.3981461046127px 932.6329728536747px',
							'840.8775104833371px 933.1061575811079px',
							'814.1672919885235px 936.3054513352462px',
							'787.2593246523946px 940.8607371441184px',
							'736.4308099757228px 954.3288457294196px',
							'689.9951445596998px 966.0807768704481px',
							'653.0090487751049px 976.9428382255574px',
							'647.3520194217613px 979.3087618627235px',
							'647.3520194217613px 979.3087618627235px',
							'635.013904215405px 985.1988523504746px',
							'627.1039505627897px 990.1284484661223px',
							'617.4283822555727px 997.5369675568307px',
							'608.3531229309203px 1005.044361068197px',
							'598.8682410064004px 1013.5616861619952px',
							'591.495034208784px 1020.8077687044803px',
							'580.7459721915692px 1031.5497682630767px',
							'565.3356874862062px 1045.85124696535px',
							'548.0609137055837px 1061.4804678878836px',
							'522.8479364378725px 1081.1635400573825px',
							'504.97285367468555px 1092.9013462811743px',
							'493.60229529905104px 1100.1898035753698px',
							'488.5032001765615px 1103.1348488192452px',
							'483.48885455749286px 1105.8115206356213px',
							'479.3008165967778px 1108.2763186934453px',
							'478.2696976384904px 1108.9543147208124px',
							'478.2696976384904px 1108.9543147208124px',
							'478.43213418671377px 1109.2791878172588px',
							'479.47737806223796px 1110.8046788788347px',
							'479.8093136173031px 1111.2637386890312px',
							'484.0397263297286px 1114.1875965570514px',
							'491.0598101964247px 1116.991392628559px',
							'491.0598101964247px 1116.991392628559px',
							'512.2966232619731px 1121.9280512028251px',
							'520.5455749282719px 1123.1216067093358px',
							'527.0571617744428px 1123.8419774884132px',
							'531.7607592143015px 1124.5199735157803px',
							'540.4193334804679px 1125.558154932686px',
							'540.4193334804679px 1125.558154932686px',
							'543.9435003310527px 1126.059589494593px',
							'546.9238578680204px 1126.532774222026px',
							'549.9395276980799px 1127.034208783933px',
							'552.5032001765614px 1127.3237695872876px',
							'554.7984992275436px 1128.2418892076805px',
							'557.1644228647098px 1129.188258662547px',
							'559.9611564775988px 1130.3253145001104px',
							'563.4358861178548px 1132.0273670271463px',
							'567.1789891856102px 1134.6404767159568px',
							'570.6466563672478px 1137.267711322004px',
							'573.2456411388215px 1139.4994482454206px',
							'577.4901787684838px 1142.0348708894285px',
							'580.0679761642022px 1143.8499227543589px',
							'583.6486426837344px 1145.7920988744206px',
							'586.6996248068859px 1147.5435886117855px',
							'588.9384241889207px 1148.8148311630987px',
							'589.9342308541161px 1149.3092032663872px',
							'591.0006621054955px 1149.7965129110573px',
							'591.2831604502318px 1150.001324210991px',
							'591.2831604502318px 1150.001324210991px',
							'591.2831604502318px 1149.8530125800046px',
							'591.2831604502318px 1149.8530125800046px',
							'591.5162215846392px 1148.489958066652px',
							'593.0275877289782px 1145.4601633193556px',
							'599.9629220922534px 1138.3553299492387px',
							'612.1386007503862px 1134.294416243655px',
							'622.4497903332598px 1128.7645111454426px',
							'672.5932465239462px 1123.1004193334804px',
							'759.9417347163982px 1112.4007945265946px',
							'846.62635179872px 1099.4482454204372px',
							'930.0339880821011px 1097.7885676451115px',
							'1043.838446259104px 1105.0205252703597px',
							'1095.6698300595895px 1112.11123372324px',
							'1132.9525491061577px 1119.703376738027px',
							'1142.0913705583757px 1122.0622379165748px',
							'1144.1182961818583px 1123.439417347164px',
							'1146.300595894946px 1126.1090267049217px',
							'1148.5747075700729px 1130.0145663209005px',
							'1151.2655043036857px 1133.4681085853013px',
							'1157.1273449569633px 1139.1816376075922px',
							'1160.7009490178768px 1142.063120723902px',
							'1162.9397483999119px 1143.5179871992939px',
							'1167.148973736482px 1145.6296623261974px',
							'1175.1436768925182px 1148.906643125138px',
							'1182.3685720591482px 1152.0423747517104px',
							'1192.8704480247186px 1157.070845288016px',
							'1209.7144118296183px 1161.5131317589937px',
							'1227.4270580445818px 1163.0033105274774px',
							'1252.8236592363717px 1163.4906201721476px',
							'1274.3147208121827px 1162.5936879276098px',
							'1298.0092694769367px 1161.223570955639px',
							'1319.2107702493931px 1161.0046347384684px',
							'1333.0743765173252px 1161.0046347384684px',
							'1343.096005296844px 1160.7150739351137px',
							'1346.4365482233504px 1160.6232619730745px',
							'1346.549547561245px 1160.6232619730745px',
							'1346.726109026705px 1160.665636724785px',
							'1346.726109026705px 1160.665636724785px',
							'1347.6936658574266px 1160.9057603178107px',
							'1348.322224674465px 1161.0752593246525px',
							'1349.0143456190688px 1161.3718825866256px',
							'1349.3886559258442px 1161.5555065107042px',
							'1349.7276539395277px 1161.725005517546px',
							'1350.688148311631px 1161.7744427278747px',
							'1352.5667623041272px 1162.0075038622822px',
							'1352.616199514456px 1162.0075038622822px',
							'1352.616199514456px 1162.0075038622822px',
							'1352.7786360626794px 1162.0075038622822px',
							'1353.0470094901789px 1161.6543809313619px',
							'1353.0470094901789px 1161.6543809313619px',
							'1353.3083204590598px 1160.079452659457px',
							'1353.6826307658355px 1158.6457735599206px',
							'1353.7038181416906px 1158.3844625910397px',
							'1353.8803796071509px 1157.4380931361732px',
							'1353.8803796071509px 1156.8236592363717px',
							'1353.8803796071509px 1156.4069741778858px',
							'1353.8803796071509px 1156.2021628779519px',
							'1353.8803796071509px 1156.1597881262414px',
							'1353.8803796071509px 1156.0185389538733px',
							'1354.0781284484663px 1155.580666519532px',
							'1354.0993158243214px 1155.4535422644008px',
							'1354.0993158243214px 1155.2557934230854px',
							'1354.0993158243214px 1155.05804458177px',
							'1354.0993158243214px 1154.9167954094019px',
							'1354.0993158243214px 1154.9167954094019px',
							'1354.2688148311631px 1154.7402339439418px',
							'1354.2688148311631px 1154.7402339439418px',
							'1355.9567424409624px 1152.0918119620394px',
							'1355.9567424409624px 1152.0918119620394px',
							'1361.7408960494372px 1145.834473626131px',
							'1365.1944383138382px 1141.7311851688369px',
							'1368.753917457515px 1136.88633855661px',
							'1369.7426616640919px 1134.520414919444px',
							'1371.6000882807327px 1129.2800706245862px',
							'1371.6000882807327px 1129.2800706245862px',
							'1373.6905760317811px 1112.8881041712648px',
							'1374.0154491282278px 1105.529022290885px',
							'1374.2202604281617px 1092.16685058486px',
							'1374.2202604281617px 1092.16685058486px',
							'1374.5804458177004px 1084.9702052527036px',
							'1374.8417567865813px 1080.3654822335027px',
							'1375.131317589936px 1075.3652615316707px',
							'1375.3643787243434px 1072.067093356875px',
							'1375.6256896932246px 1068.4864268373428px',
							'1375.9505627896713px 1066.0640035312294px',
							'1376.1977488413154px 1064.2277642904437px',
							'1376.3319355550652px 1063.2743323769587px',
							'1376.3389980136835px 1062.6740233943942px',
							'1376.3389980136835px 1062.2290885014347px',
							'1376.381372765394px 1062.1796512911058px',
							'1376.536746854999px 1062.0172147428825px',
							'1376.536746854999px 1062.0172147428825px',
							'1373.7470757007284px 1062.7093356874864px',
							'1373.7470757007284px 1062.7093356874864px',
							'1365.0814389759437px 1063.747517104392px',
							'1351.1825204149195px 1065.5837563451778px',
							'1318.5680865151182px 1069.1291105716177px',
							'1273.481350695211px 1073.3171485323328px',
							'1215.5409401898037px 1077.54049878614px',
							'1180.1650849702053px 1079.7581107923197px',
							'1168.1094681085854px 1079.9487971750166px',
							'1159.2460825424853px 1079.9487971750166px',
							'1154.39417347164px 1079.9487971750166px',
							'1148.8854557492828px 1079.7722357095565px',
							'1140.5729419554184px 1079.6874862061356px',
							'1132.5711763407637px 1079.991171926727px',
							'1114.646656367248px 1080.5420436989627px',
							'1087.2301920105938px 1081.7709114985655px',
							'1059.0792319576253px 1082.7102184948135px',
							'1015.9699845508718px 1084.8289560803355px',
							'966.1019642463033px 1087.8870006621055px',
							'930.118737585522px 1091.178106378283px',
							'909.5811079231959px 1092.7106598984772px',
							'886.8046788788347px 1094.320900463474px',
							'868.5482233502538px 1095.3732067976164px',
							'849.4018980357538px 1096.8633855661003px',
							'840.4961377179432px 1098.0710659898477px',
							'838.1725888324873px 1098.5513131758994px',
							'836.1739130434784px 1099.0598101964247px',
							'828.6453321562569px 1101.637607592143px',
							'816.4767159567425px 1106.4047671595674px',
							'797.5281394835578px 1113.4107261090269px',
							'784.8015890531892px 1117.7470757007284px',
							'772.6965349812403px 1122.274111675127px',
							'768.0494372103288px 1124.3010372986096px',
							'759.4685499889649px 1128.354888545575px',
							'752.8792760979917px 1132.9525491061577px',
							'745.6896932244538px 1139.111013021408px',
							'736.0635621275657px 1146.9362171706025px',
							'733.0337673802693px 1149.74001324211px',
							'732.2427720150077px 1150.53807106599px',
							'732.2286470977709px 1150.5521959832267px',
							'732.2286470977709px 1150.5521959832267px',
							'732.2922092253366px 1150.0931361730304px',
							'732.8713308320459px 1146.6395939086294px',
							'734.4391966453322px 1136.9569631427942px',
							'734.4391966453322px 1136.9569631427942px',
							'736.2189362171706px 1121.7303023615098px',
							'737.3559920547341px 1106.708452880159px',
							'738.154049878614px 1094.546899139263px',
							'738.2882365923638px 1088.9110571617746px',
							'738.9026704921652px 1082.0887221363937px',
							'738.9450452438756px 1077.7099977929818px',
							'739.8349150297948px 1066.7773118516884px',
							'740.0891635400575px 1062.7517104391968px',
							'740.0891635400575px 1062.7517104391968px',
							'740.2869123813728px 1060.0891635400574px',
							'740.3363495917016px 1057.370116971971px',
							'740.3363495917016px 1055.7457514897374px',
							'740.3363495917016px 1053.3303906422425px',
							'740.3363495917016px 1049.9262855881705px',
							'740.3010372986096px 1045.7947472964026px',
							'739.9973515780182px 1042.7155153387773px',
							'739.630103729861px 1040.384903994703px',
							'739.4323548885457px 1038.591039505628px',
							'739.1569190024278px 1037.305672037078px',
							'738.9097329507836px 1036.1686161995144px',
							'738.7826086956522px 1035.6601191789894px',
							'738.761421319797px 1035.3564334583978px',
							'738.761421319797px 1034.9962480688591px',
							'738.761421319797px 1034.9962480688591px',
							'738.761421319797px 1034.890311189583px',
							'738.6625468991393px 1034.629000220702px',
							'738.5495475612448px 1034.2264400794527px',
							'738.5495475612448px 1034.0498786139926px',
							'738.5495475612448px 1033.8733171485324px',
							'738.5495475612448px 1033.8380048554404px',
							'738.5495475612448px 1033.8380048554404px',
							'738.5071728095344px 1033.79563010373px',
							'738.2811741337454px 1033.5131317589937px',
							'738.2811741337454px 1033.3577576693888px',
							'738.2811741337454px 1033.0258221143235px',
							'738.2811741337454px 1032.425513131759px',
							'738.2811741337454px 1031.2319576252482px',
							'738.2811741337454px 1030.3774001324211px',
							'738.2811741337454px 1029.1414698742px',
							'738.2811741337454px 1027.3405429265063px',
							'738.309423968219px 1026.3164864268374px',
							'738.4647980578239px 1024.988744206577px',
							'738.4647980578239px 1024.2471860516443px',
							'738.4647980578239px 1023.858750827632px',
							'738.4647980578239px 1023.858750827632px',
							'728.7256676230413px 1026.8108585301259px',
							'728.7256676230413px 1026.8108585301259px',
							'673.3489295961157px 1044.7636283381153px',
							'650.318252041492px 1053.669388655926px',
							'632.3866696093578px 1059.714853233282px',
							'611.9196645332156px 1064.9905098212316px',
							'605.4645773559921px 1066.3606267932025px',
							'600.6621054954757px 1067.3140587066873px',
							'600.6621054954757px 1067.3140587066873px',
							'593.2182741116752px 1068.768925182079px',
							'586.388876627676px 1070.068417567866px',
							'581.9183403222247px 1070.9441624365484px',
							'578.2599867578901px 1071.721032884573px',
							'576.416685058486px 1072.3566541602295px',
							'575.0536305451336px 1072.8722136393733px',
							'572.45464577356px 1073.3948355771354px',
							'569.919223129552px 1073.9245199735158px',
							'566.5080556168616px 1074.7720150077246px',
							'562.0163319355551px 1075.852571176341px',
							'556.9878613992496px 1077.0602516000883px',
							'550.91414698742px 1078.409181196204px',
							'544.3036857205915px 1079.5179871992939px',
							'538.1664091811963px 1080.2312955197528px',
							'526.7958508055617px 1081.121165305672px',
							'524.6771132200398px 1081.255352019422px',
							'523.3917457514898px 1081.361288898698px',
							'521.5766938865593px 1081.4389759435005px',
							'519.2319576252484px 1081.6225998675789px',
							'519.2319576252484px 1081.6225998675789px',
							'515.5806665195321px 1081.4460384021188px',
							'510.50275877289783px 1081.3754138159347px',
							'506.7384683292872px 1081.3754138159347px',
							'504.0759214301479px 1081.3754138159347px',
							'503.0306775546237px 1081.3754138159347px',
							'501.4769366585743px 1081.3754138159347px',
							'500.6718163760759px 1081.3754138159347px',
							'500.6718163760759px 1081.3754138159347px',
							'500.6718163760759px 1081.4177885676452px',
							'500.6718163760759px 1081.4177885676452px',
							'500.7353785036416px 1081.8415360847496px',
							'501.73824762745534px 1083.3034650187597px',
							'503.37673802692564px 1085.288015890532px',
							'505.35422644007946px 1087.5762524828956px',
							'505.35422644007946px 1087.5762524828956px',
							'517.3815934672258px 1098.6713749724124px',
							'529.2182741116752px 1108.5446921209448px',
							'529.2182741116752px 1108.5446921209448px',
							'533.2509379827853px 1111.8499227543589px',
							'535.729860957846px 1113.8768483778415px',
							'538.9997792981682px 1116.087397925403px',
							'538.9997792981682px 1116.087397925403px',
							'542.5592584418451px 1118.453321562569px',
							'544.3672478481571px 1119.7951887000663px',
							'544.3672478481571px 1119.7951887000663px',
							'548.1597881262414px 1122.5989847715737px',
							'550.91414698742px 1124.7883469432797px',
							'552.0512028249835px 1125.7276539395277px',
							'553.1600088280733px 1126.5610240564997px',
							'553.1600088280733px 1126.5610240564997px',
							'554.4453762966233px 1127.6839549768263px',
							'554.6996248068859px 1128.0017656146547px',
							'554.6996248068859px 1128.0017656146547px',
							'554.7278746413596px 1128.0653277422202px',
							'554.7278746413596px 1128.0653277422202px',
							'554.8620613551093px 1127.7192672699184px',
							'554.8620613551093px 1127.7192672699184px',
							'554.734937099978px 1124.1386007503863px',
							'547.178106378283px 1094.0172147428825px',
							'545.4548664753918px 1077.5263738689032px',
							'538.0180975502097px 1023.3220039726331px',
							'531.231074817921px 975.4809092915472px',
							'529.6843963804899px 948.0503200176562px',
							'530.1081438975943px 923.0421540498787px',
							'533.8794967998234px 882.2423306113441px',
							'539.8896490840874px 855.383800485544px',
							'545.3983668064445px 841.8450673140587px',
							'548.8589715294637px 830.4956963142795px',
							'548.8589715294637px 829.4645773559921px',
							'548.8589715294637px 828.0944603840212px',
							'548.8589715294637px 827.0633414257339px',
							'548.7530346501876px 826.3994703156037px',
							'548.7318472743324px 826.335908188038px',
							'548.2586625468991px 826.1028470536306px',
							'547.4182299713088px 825.9121606709336px',
							'545.5043036857206px 825.7355992054735px',
							'539.4164643566542px 825.0011035091592px',
							'525.7647318472743px 824.2454204369897px',
							'513.3277422202605px 823.3979254027809px',
							'503.5321121165306px 822.5363054513354px',
							'501.43456190686385px 822.373868903112px',
							'500.9543147208122px 822.1619951445598px',
							'499.9443831383801px 821.3215625689694px',
							'498.96976384903996px 820.0715073935114px',
							'498.53189141469875px 819.0545133524608px',
							'498.42595453542265px 818.1575811079232px',
							'498.327080114765px 817.1688369013464px',
							'497.95276980798945px 815.7351578018098px',
							'497.5784595012139px 814.5698521297727px',
							'497.19002427720153px 813.4045464577357px',
							'496.79452659457075px 812.2251158684618px',
							'496.79452659457075px 811.6742440962261px',
							'496.79452659457075px 811.1021849481351px',
							'496.79452659457075px 809.6473184727433px',
							'496.79452659457075px 807.6980798940632px',
							'496.79452659457075px 805.0708452880159px',
							'496.79452659457075px 802.8461708232179px',
							'496.89340101522845px 801.6031781063783px',
							'497.33833590818807px 799.51269035533px',
							'497.5643345839771px 797.8883248730965px',
							'497.7620834252925px 796.263959390863px',
							'497.95276980798945px 794.335908188038px',
							'497.95983226660786px 793.7850364158023px',
							'497.9739571838447px 793.6084749503422px',
							'497.9739571838447px 793.4107261090268px',
							'497.9739571838447px 793.4107261090268px',
							'497.9739571838447px 793.0929154711985px',
							'497.9739571838447px 792.6762304127125px',
							'497.9739571838447px 792.6056058265284px',
							'497.9739571838447px 792.6056058265284px',
							'497.9739571838447px 792.181858309424px',
							'497.9739571838447px 792.181858309424px',
							'497.9739571838447px 791.8428602957405px',
							'497.9739571838447px 791.6874862061355px',
							'497.9739571838447px 791.6097991613331px',
							'497.9739571838447px 791.4544250717281px',
							'497.9739571838447px 791.4261752372545px',
							'498.15051864930484px 791.4261752372545px',
							'498.397704700949px 791.1931141028471px',
							'498.397704700949px 791.1931141028471px',
							'499.38644890752596px 790.9741778856765px',
							'499.4358861178548px 790.9176782167292px',
							'499.81725888324877px 790.6563672478482px',
							'500.43875524166856px 790.4515559479145px',
							'500.79894063120724px 790.4515559479145px',
							'501.1873758552196px 790.2820569410727px',
							'502.1054954756125px 790.2538071065991px',
							'502.98124034429486px 790.0419333480469px',
							'503.90642242330614px 789.8794967998235px',
							'504.6126682851468px 789.8794967998235px',
							'505.5237254469212px 789.7876848377842px',
							'506.40653277422206px 789.6746854998897px',
							'506.7808430809976px 789.6746854998897px',
							'506.83734274994487px 789.6746854998897px',
							'506.83734274994487px 789.6746854998897px',
							'503.8357978371221px 789.6746854998897px',
							'491.9920547340543px 789.6746854998897px',
							'476.4193334804679px 790.3809313617304px',
							'459.5471198410947px 791.8216729198853px',
							'436.6506290002207px 793.5731626572501px',
							'413.4716398146105px 797.4433899801369px',
							'398.1461046126683px 799.9081880379607px',
							'381.4716398146105px 802.2599867578901px',
							'369.51489737364824px 804.046788788347px',
							'357.2685941293313px 805.5016552637387px',
							'341.66762304127127px 807.6698300595896px',
							'319.9858750827632px 810.9044361068197px',
							'299.9638048995807px 813.6164202162878px',
							'277.159126020746px 815.8905318914148px',
							'266.4241889207681px 817.4513352460826px',
							'243.4288236592364px 821.3215625689694px',
							'225.94217612006182px 824.1041712646215px',
							'203.73780622379167px 827.6283381152064px',
							'185.8344736261311px 830.5592584418451px',
							'172.26042816155376px 832.7203707790775px',
							'167.42264400794528px 833.4901787684838px',
							'164.80953431913485px 833.8856764511146px',
							'163.58066651953212px 834.0198631648643px',
							'160.6285588170382px 834.3164864268374px',
							'158.60869565217394px 834.7331714853234px',
							'156.56058265283602px 835.1004193334805px',
							'152.07592143014787px 835.9126020745973px',
							'148.67181637607592px 836.7035974398588px',
							'143.45972191569192px 837.4734054292651px',
							'136.9905098212315px 838.6810858530126px',
							'132.04678878834696px 839.5850805561687px',
							'127.66100198631649px 840.1500772456412px',
							'121.98278525711764px 841.0893842418892px',
							'120.05473405429265px 841.3789450452439px',
							'119.48973736482013px 841.4636945486648px',
							'118.83999117192674px 841.5766938865593px',
							'118.61399249613773px 841.5837563451777px',
							'118.22555727212537px 841.5837563451777px',
							'118.11962039284927px 841.5837563451777px',
							'118.11962039284927px 841.5837563451777px',
							'119.03067755462371px 841.8097550209667px',
							'125.87419995585964px 842.8973736482013px',
							'154.56896932244538px 848.971088060031px',
							'179.15338777311854px 859.6000882807327px',
							'213.78062237916575px 888.59854336791px',
							'253.9518870006621px 927.251379386449px',
							'322.5848598543368px 990.6722577797397px',
							'408.65504303685725px 1064.1077024939307px',
							'513.2924299271684px 1155.1427940851909px',
							'589.4822335025381px 1229.3551092474067px',
							'661.2156256896933px 1310.001324210991px',
							'681.5978812624145px 1336.4149194438314px',
							'692.516442286471px 1353.364820128007px',
							'692.8060030898257px 1353.901566983006px',
							'692.8060030898257px 1353.901566983006px',
							'692.8060030898257px 1353.5625689693225px',
							'692.445817700287px 1352.1218274111675px',
							'692.445817700287px 1352.1218274111675px',
							'687.6715956742441px 1342.3968218936218px',
							'683.5894945928052px 1327.615096005297px',
							'683.5894945928052px 1327.615096005297px',
							'682.8267490620173px 1311.8305009931582px',
							'685.3833590818804px 1288.3760759214301px',
							'688.2295299050983px 1267.0333259766057px',
							'689.3030236150961px 1260.9172368130655px',
							'689.3030236150961px 1260.9172368130655px',
							'689.3453983668065px 1261.0372986095786px',
							'690.1575811079232px 1262.7534760538513px',
							'691.8455087177224px 1265.3312734495696px',
							'693.3639373206798px 1266.553078790554px',
							'695.1719267269918px 1266.9062017214744px',
							'697.467225777974px 1267.0615758110794px',
							'700.14389759435px 1266.327080114765px',
							'701.5563893180314px 1265.8538953873317px',
							'701.6340763628339px 1265.8185830942398px',
							'701.6340763628339px 1265.7479585080557px',
							'701.6340763628339px 1265.7408960494372px',
							'701.6340763628339px 1265.7408960494372px',
							'701.5705142352682px 1265.6208342529244px',
							'701.2103288457295px 1264.519090708453px',
							'700.334583977047px 1261.1714853233282px',
							'698.9997792981682px 1257.117634076363px',
							'698.9997792981682px 1257.117634076363px',
							'695.4403001544913px 1247.82343853454px',
							'694.4586184065328px 1244.193334804679px',
							'693.8865592584419px 1240.4784815713972px',
							'693.6181858309425px 1237.5828735378504px',
							'692.3540057382477px 1230.4215404987863px',
							'692.3540057382477px 1230.4215404987863px',
							'691.9867578900905px 1228.698300595895px',
							'691.5418229971309px 1226.6572500551756px',
							'691.3016994041051px 1225.4283822555728px',
							'691.1180754800265px 1224.284263959391px',
							'690.7649525491062px 1223.1048333701171px',
							'690.5813286250276px 1222.4338998013684px',
							'690.2211432354889px 1221.8759655705144px',
							'689.8468329287133px 1221.0990951224896px',
							'689.790333259766px 1220.8942838225557px',
							'689.649084087398px 1220.5905981019644px',
							'689.5431472081219px 1220.4422864709777px',
							'689.4372103288458px 1220.3363495917017px',
							'689.4372103288458px 1220.2304127124255px',
							'689.4372103288458px 1220.188037960715px',
							'689.232399028912px 1219.9832266607814px',
							'689.232399028912px 1219.806665195321px',
							'689.19708673582px 1219.3264180092694px',
							'689.006400353123px 1218.9803575369676px',
							'688.9145883910837px 1218.7331714853235px',
							'688.6885897152947px 1218.1469874199956px',
							'688.4767159567425px 1217.8291767821675px',
							'688.4767159567425px 1217.2994923857868px',
							'688.3213418671376px 1216.6497461928934px',
							'688.2930920326639px 1216.070624586184px',
							'688.0882807327301px 1215.1948797175016px',
							'688.0529684396381px 1214.3685720591482px',
							'687.8905318914148px 1213.3021408077689px',
							'687.8057823879939px 1212.0944603840212px',
							'687.6080335466785px 1210.893842418892px',
							'687.5374089604944px 1209.834473626131px',
							'687.4032222467447px 1208.6197307437653px',
							'687.3537850364158px 1206.896490840874px',
							'687.1984109468109px 1205.561686161995px',
							'687.1842860295741px 1204.4740675347607px',
							'687.1842860295741px 1203.1322003972634px',
							'687.1277863606268px 1202.4895166629883px',
							'686.922975060693px 1201.5360847495035px',
							'686.8241006400353px 1200.921650849702px',
							'686.8241006400353px 1200.1800926947694px',
							'686.8241006400353px 1199.7916574707572px',
							'686.6475391745752px 1199.2125358640478px',
							'686.6122268814831px 1198.8664753917458px',
							'686.3932906643125px 1198.209666740234px',
							'686.2591039505628px 1197.842418892077px',
							'686.1743544471419px 1197.0231736923417px',
							'686.0472301920106px 1196.3593025822115px',
							'686.0472301920106px 1195.9638048995807px',
							'686.0472301920106px 1195.6106819686604px',
							'686.0472301920106px 1195.0174354447142px',
							'686.0472301920106px 1194.8479364378725px',
							'686.0472301920106px 1194.1416905760318px',
							'686.0472301920106px 1193.8380048554404px',
							'686.0472301920106px 1193.4425071728097px',
							'686.0472301920106px 1193.0470094901789px',
							'686.0472301920106px 1192.545574928272px',
							'686.0472301920106px 1192.1712646214964px',
							'685.8989185610241px 1191.8817038181417px',
							'685.8141690576032px 1191.6627676009712px',
							'685.8141690576032px 1191.4862061355109px',
							'685.8141690576032px 1191.4579563010375px',
							'685.8141690576032px 1191.4579563010375px',
							'685.8141690576032px 1191.3590818803798px',
							'685.8141690576032px 1191.1825204149195px',
							'685.8141690576032px 1191.0624586184067px',
							'685.8141690576032px 1190.998896490841px',
							'685.8141690576032px 1190.8364599426177px',
							'685.8141690576032px 1190.8152725667624px',
							'685.8141690576032px 1190.6316486426838px',
							'685.8141690576032px 1190.5892738909733px',
							'685.8141690576032px 1190.4056499668948px',
							'685.8141690576032px 1190.2714632531452px',
							'685.8141690576032px 1190.1725888324875px',
							'685.8141690576032px 1190.0878393290666px',
							'685.8141690576032px 1190.0878393290666px',
							'685.9695431472081px 1190.0878393290666px',
							'687.3467225777974px 1190.0878393290666px',
							'693.9430589273892px 1190.0878393290666px',
							'707.7148532332819px 1190.0878393290666px',
							'731.3882145221805px 1189.7559037740014px',
							'776.0582652836019px 1190.080776870448px',
							'818.4895166629883px 1192.2983888766278px',
							'848.4625910395057px 1195.56830721695px',
							'850.7578900904878px 1195.8366806444494px',
							'857.6649746192894px 1196.4440520856324px',
							'862.2626351798721px 1196.9454866475392px',
							'864.8263076583536px 1197.3339218715516px',
							'866.2599867578901px 1197.6234826749062px',
							'866.4718605164423px 1197.6941072610903px',
							'866.4718605164423px 1197.6941072610903px',
							'866.2599867578901px 1197.6941072610903px',
							'866.1964246303245px 1197.6941072610903px',
							'865.2218053409844px 1197.6941072610903px',
							'864.1059368792761px 1197.6941072610903px',
							'862.5521959832267px 1197.6941072610903px',
							'861.1820790112558px 1197.6941072610903px',
							'859.9108364599426px 1197.6941072610903px',
							'858.9644670050762px 1197.6941072610903px',
							'858.9644670050762px 1197.6941072610903px',
							'857.3612888986979px 1197.6941072610903px',
							'855.8852350474509px 1197.6941072610903px',
							'855.8852350474509px 1197.6941072610903px',
							'854.5151180754801px 1197.6941072610903px',
							'853.1450011035092px 1197.6941072610903px',
							'852.2268814831164px 1197.7506069300375px',
							'851.4711984109468px 1197.863606267932px',
							'851.4711984109468px 1197.863606267932px',
							'850.9838887662768px 1197.863606267932px',
							'849.7973957183846px 1197.863606267932px',
							'848.7168395497683px 1197.863606267932px',
							'847.3749724122711px 1197.8706687265505px',
							'846.3579783712205px 1198.0331052747738px',
							'846.3579783712205px 1198.0331052747738px',
							'845.8494813506952px 1198.0331052747738px',
							'845.8494813506952px 1198.0331052747738px',
							'845.4327962922093px 1198.209666740234px',
							'845.3974839991173px 1198.209666740234px',
							'845.3974839991173px 1198.209666740234px',
							'845.5104833370117px 1198.7887883469434px',
							'846.4427278746414px 1203.0686382696977px',
							'847.4455969984551px 1207.051864930479px',
							'848.1235930258222px 1207.743985875083px',
							'850.6519532112117px 1209.3047892297507px',
							'853.3851246965351px 1211.16927830501px',
							'856.4290443610682px 1212.9843301699404px',
							'860.1156477598764px 1215.1030677554625px',
							'861.2527035974399px 1215.8587508276319px',
							'862.1213860075039px 1216.4378724343412px',
							'863.1736923416465px 1217.1935555065108px',
							'863.7881262414479px 1217.6596777753257px',
							'863.9152504965791px 1217.7444272787466px',
							'863.9152504965791px 1217.7444272787466px',
							'863.9152504965791px 1217.963363495917px',
							'863.3643787243435px 1222.3703376738029px',
							'860.5323328183624px 1231.2902229088502px',
							'856.2807327300817px 1247.1383800485544px',
							'849.4372103288458px 1264.9075259324652px',
							'840.806885897153px 1289.1741337453102px',
							'839.3943941734717px 1301.3498124034431px',
							'838.5398366806445px 1318.010152284264px',
							'838.3774001324211px 1324.0838666960938px',
							'838.3774001324211px 1330.1434561906865px',
							'838.3774001324211px 1336.6903553299494px',
							'838.1372765393953px 1342.6157581107925px',
							'837.6005296843964px 1347.7219156919002px',
							'837.0355329949239px 1352.5667623041272px',
							'836.724784815714px 1357.9766056058265px',
							'836.534098433017px 1360.3495917016112px',
							'836.3857868020305px 1362.0587066872656px',
							'836.3857868020305px 1362.277642904436px',
							'836.3857868020305px 1362.277642904436px',
							'836.3857868020305px 1362.4400794526596px',
							'836.534098433017px 1362.6872655043037px',
							'837.0072831604502px 1364.2268814831164px',
							'838.8011476495255px 1373.9730743765174px',
							'842.7914367689252px 1403.5082763186936px',
							'864.7344956963143px 1488.9145883910837px',
							'889.6014124917237px 1564.7724564113882px',
							'889.6014124917237px 1564.7724564113882px',
							'914.9344515559479px 1648.2154049878616px',
							'928.0847495034209px 1710.696976384904px',
							'948.9543147208122px 1831.7122048113001px',
							'951.920547340543px 1876.897815051865px',
							'950.2396821893623px 1901.5034208783934px',
							'944.8651511807549px 1937.2747737806226px',
							'943.1842860295741px 1952.6144338998015px',
							'941.1008607371442px 1965.0372986095786px',
							'940.4228647097772px 1972.1209446038404px',
							'939.8931803133967px 1985.490178768484px',
							'939.8931803133967px 1993.0187596557053px',
							'939.6530567203708px 1995.914367689252px',
							'939.2151842860296px 1997.5175457956302px',
							'937.2730081659678px 2000.8369013462814px',
							'935.069521077025px 2005.22975060693px',
							'932.5129110571619px 2010.6890311189584px',
							'931.5171043919665px 2012.9984550871773px',
							'931.3829176782168px 2013.2597660560584px',
							'931.142794085191px 2013.7329507834916px',
							'931.1004193334805px 2014.6722577797398px',
							'931.4817920988745px 2015.8305009931585px',
							'931.8772897815053px 2016.5791216067094px',
							'931.9196645332157px 2016.6638711101302px',
							'931.9196645332157px 2016.6638711101302px',
							'931.9196645332157px 2016.882807327301px',
							'931.9196645332157px 2016.9251820790114px',
							'931.9196645332157px 2016.9393069962482px',
							'931.8772897815053px 2017.1370558375636px',
							'931.7077907746635px 2017.2994923857868px',
							'931.6512911057163px 2017.2994923857868px',
							'931.4606047230193px 2017.2994923857868px',
							'931.3829176782168px 2017.2994923857868px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const Composition3DRotation = () => {
	return (
		<Composition
			id="3DRotation"
			component={Composition3DRotationPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={1115}
		/>
	);
};
